// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p.data[data-v-9b8427aa] {\n  margin-bottom: 0px !important;\n}\n.row .cell[data-v-9b8427aa] {\n  padding-top: 5px !important;\n}\n@media only screen and (max-width: 768px) {\n.border-right--variant[data-v-9b8427aa] {\n    border-right: unset !important;\n}\n}", ""]);
// Exports
module.exports = exports;
